var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Global, Module } from '@nestjs/common';
import { ConfigModule, ConfigService } from '@nestjs/config';
import { ArchetypeController } from './controllers/archetype.controller';
import { ArchetypeService } from './services/archetype.service';
import { CONFIG_OPTIONS } from './constants/archetype.constants';
let ArchetypeModule = class ArchetypeModule {
};
ArchetypeModule = __decorate([
    Global(),
    Module({
        imports: [ConfigModule],
        controllers: [ArchetypeController],
        exports: [CONFIG_OPTIONS, ArchetypeController],
        providers: [
            ArchetypeController,
            ArchetypeService,
            {
                provide: CONFIG_OPTIONS,
                useFactory: async (configService) => configService.get('config'),
                inject: [ConfigService],
            },
        ],
    })
], ArchetypeModule);
export { ArchetypeModule };
